import { observer } from "mobx-react-lite";
import authStore from "../../../stores/AuthStore";
import "./UserDashboard.scss";
import useTranslation from "../../../hooks/useTranslation";
import { Link, useNavigate } from "react-router-dom";
import UserCases from "../../UserCases";
import OffersSummary from "../../../components/Offer/OffersSummary";
import caseStore from "../../../stores/CaseStore";
import offerStore from "../../../stores/OfferStore";
import configStore from "../../../stores/ConfigStore";
import { Card, Tooltip } from "@mui/material";
import { UserRoles } from "../../../stores/AuthStore/types";
import { CaseStatus } from "../../../stores/CaseStore/types";

const UserDashboard = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const activeCasesCount = caseStore.userCases.filter(
    (caseItem) => caseItem.status !== CaseStatus.COMPLETED
  ).length;

  return (
    <>
      {!authStore.userHasRole(UserRoles.LAWYER) && (
        <Card
          elevation={1}
          className="pl mb"
          onClick={() => navigate("/cases")}
        >
          <h4>
            <Link to="/cases">
              <i
                className="fal fa-external-link"
                style={{ fontSize: "14px", marginRight: "5px" }}
              />
              <Tooltip
                title={t("your-case-limit", [
                  `${configStore.appConfig.caseLimit}`,
                ])}
                placement={"top-start"}
              >
                <span>
                  {t("your-cases")} ({activeCasesCount} /{" "}
                  {configStore.appConfig.caseLimit})
                </span>
              </Tooltip>
            </Link>
          </h4>
          <div className="userCasesSummaryContainer">
            {caseStore.userCases.length > 0 ? (
              <UserCases summaryMode={true} />
            ) : (
              <div>
                <p
                  className="mt0 pt0"
                  dangerouslySetInnerHTML={{
                    __html: t("greet-user", [authStore.user?.firstName || ""]),
                  }}
                />
                <p dangerouslySetInnerHTML={{ __html: t("are-you-lawyer") }} />
              </div>
            )}
          </div>
        </Card>
      )}
      <Card
        elevation={1}
        className="pl mb"
        onClick={() => navigate("/incoming-offers")}
      >
        <h4>
          <Link to="/incoming-offers">
            <i
              className="fal fa-external-link"
              style={{ fontSize: "14px", marginRight: "5px" }}
            />
            <span>
              {t("incoming-offers")} ({offerStore.userOffers.length})
            </span>
          </Link>
        </h4>
        <div className="userCasesSummaryContainer">
          {offerStore.userOffers.length > 0 ? (
            <OffersSummary
              rawOffers={offerStore.userOffers}
              summaryMode={true}
            />
          ) : (
            <div className="mb">{t("has-no-offer")}</div>
          )}
        </div>
      </Card>
    </>
  );
});

export default UserDashboard;
